import './Loader.css';

export default function Loader() {
    return (
        <div className="loader-container">
            <div className="netflix-loader"></div>
        </div>
    );
}
